export default __webpack_public_path__ + "static/media/Mirto.eeb309be.jpg";